module.exports = __webpack_public_path__ + "media/images/LES_stamp-db2ad62194d28b72ad146ec3e381944b.jpg";